
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import TranServiceOverviewContent from "@/components/transService/TranServiceOverviewContent.vue";
import { IBreadCrumbRoute } from "@/types";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "transportation-services",
  components: { HeroBanner, BreadCrumb, TranServiceOverviewContent },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transServicesOverview" },
          text: "Transportation Services",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "TSO_HERO_C,TSO_CON_SR,TSO_CON_FR,TSO_CON_OT,TSO_CON_S1,TSO_CON_S2,TSO_CON_S3,TSO_FOOTER,TRN_SRVC,TRS_FRT,TRN_SRD,SRS_VIDEO,FRS_VIDEO"
    );
  },
});
